module.exports = __webpack_public_path__ + "html/pagination_7e2f3628d90bcbe84e3ab54031620654.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/pagination.html
// module id = dTsy
// module chunks = 9